import {
  castFromInheritIfNeeded,
  convertPhysicalAlignmentToLogical,
  convertPhysicalAlignmentToLogicalRTL,
  type Direction,
  type WithInherit,
} from '@wix/editor-elements-common-utils';
import type { ExpandableMenuProperties } from '../../ExpandableMenu.types';

export const getDirectionFallbackValue = (
  legacyArrowPosition: ExpandableMenuProperties['menuArrowDirection'],
): WithInherit<Direction> =>
  legacyArrowPosition === 'right' ? 'inherit' : 'rtl';

export const getAlignFallbackValue = (
  itemsAlignment: ExpandableMenuProperties['itemsAlignment'],
  direction: WithInherit<Direction>,
) => {
  const realDirection = castFromInheritIfNeeded(direction, 'ltr');

  return realDirection === 'rtl'
    ? convertPhysicalAlignmentToLogicalRTL(itemsAlignment)
    : convertPhysicalAlignmentToLogical(itemsAlignment);
};
